<template>
  <ul class="nav">
    <li><router-link to="/user/user-bookings">All Bookings</router-link></li>
    <li><router-link to="/user/user-booking-upcoming">Upcoming</router-link></li>
    <li><router-link to="/user/user-booking-inprogress">Inprogress</router-link></li>
    <li><router-link to="/user/user-booking-complete">Completed</router-link></li>
    <li><router-link to="/user/user-booking-cancelled">Cancelled</router-link></li>
  </ul>
</template>
